import { useQuery } from '@tanstack/react-query';

import { useSitePreviewData } from '@libs/common-next';

import { useSelectedProductStore } from '@/entities/product';

import { fetchProductBase } from '../api';
import { getOnlineAt } from '../libs/get-online-at';
import { PRODUCT_BASE_QUERY_KEY } from './queryKey';

type QueryProduct = {
    locale: 'en-US' | 'en-CA';
};

const ONE_HOUR = 60 * 60 * 1000;

export const useQueryProductX = ({ locale }: QueryProduct) => {
    const sku = useSelectedProductStore(state => state.sku);
    const webStyleId = useSelectedProductStore(state => state.webStyleId);
    const onlineAt = getOnlineAt(useSitePreviewData()?.previewDate);

    const { data } = useQuery({
        queryKey: [PRODUCT_BASE_QUERY_KEY, webStyleId, locale, onlineAt],
        queryFn: () => fetchProductBase(sku, onlineAt),
        staleTime: ONE_HOUR,
        enabled: Boolean(sku) && Boolean(webStyleId),
    });

    const base = data?.data;
    const product = base?.variants[sku] || base?.variants[base.defaultSku || ''];

    return { base, product };
};
